import type { MarketplacePricingCard } from 'modules/marketplace_modules/components/Revamp/types'
import { BUSINESS_VARIANT, ENTERPRISE_VARIANT } from 'modules/upsell/lib/selfUpsell/plans/utils'
import { useSelfUpsellContext } from 'modules/upsell/store/SelfUpsellProvider'

/**
 * Builds comparison plans (name + perksExtended) from SelfUpsell context — same
 * source and logic as PricingPlan's validPlans used by ComparisonModal.
 * Must be used inside SelfUpsellProvider with availableAddons set.
 */
export function useComparisonPlansFromSelfUpsell(): MarketplacePricingCard[] {
  const { allAddons } = useSelfUpsellContext()

  const dynamicPlans = allAddons.f25Addons.flatMap((plan) => {
    const variants = plan.variantTypes.filter(
      (variant) => variant === BUSINESS_VARIANT || variant === ENTERPRISE_VARIANT
    )

    return variants.map((variant) => {
      const features = plan.getFeatures(variant)
      return { variant, features }
    })
  })

  const hasMoreThanTwoPlans = dynamicPlans.length > 2
  const limitedPlans = hasMoreThanTwoPlans ? dynamicPlans.slice(0, 2) : dynamicPlans

  return limitedPlans.map(
    ({ variant, features }): MarketplacePricingCard => ({
      __typename: 'MarketplacePricingCard',
      name: variant,
      perksExtended: features.map((f) => f.title).join('\n'),
    })
  )
}
